import { render, staticRenderFns } from "./ModalESConfirmar.vue?vue&type=template&id=70c2382a&scoped=true&"
import script from "./ModalESConfirmar.vue?vue&type=script&lang=js&"
export * from "./ModalESConfirmar.vue?vue&type=script&lang=js&"
import style0 from "./ModalESConfirmar.vue?vue&type=style&index=0&id=70c2382a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2382a",
  null
  
)

export default component.exports